/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Alpha_IndexedInputs */

const en_landing_capability_alpha_indexed = /** @type {(inputs: Landing_Capability_Alpha_IndexedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexed`)
};

/**
* | output |
* | --- |
* | "Indexed" |
*
* @param {Landing_Capability_Alpha_IndexedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_alpha_indexed = /** @type {((inputs?: Landing_Capability_Alpha_IndexedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Alpha_IndexedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_alpha_indexed(inputs)
});